// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__B9ftW","title":"BackImages_title__1XrwB","images":"BackImages_images__3cByq"};